import { useMutation, useQueryClient } from '@tanstack/react-query';
import request from '@teetsh/app/src/utils/request';
import useNotification from '@teetsh/app/src/containers/App/Notifications/useNotification';
import { Folder } from './types';
import { SEQUENCES_LIST_KEY } from 'queries/sequences/useSequencesFolders';
import { useTranslation } from 'react-i18next';

function updateFolder({ folder }: { folder: Folder }) {
  const requestURL = `/folders/${folder.id}`;
  return request(requestURL, {
    method: 'PATCH',
    body: {
      id: folder.id,
      name: folder.name,
      position: folder.position,
    },
  });
}

export function useUpdateFolder() {
  const { notifyError } = useNotification();
  const queryClient = useQueryClient();
  const { t } = useTranslation(['sequence']);
  const { mutateAsync } = useMutation({
    mutationFn: (folder: Folder) =>
      updateFolder({
        folder,
      }),

    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [SEQUENCES_LIST_KEY],
      });
    },
    onError: () => {
      notifyError({
        title: t('sequence:messages.folder.deleteError'),
      });
    },
  });
  return mutateAsync;
}
